export const userPoolId = 'us-west-2_oDPdgQRVt';

export const clientId = '1527k9f40fmf3f8jcc0uhgovvd'

export const identityPoolId = "us-west-2:2fe6fc56-a97d-4e49-a6ab-454d51d8b853";

export const apiURL = "https://api.correlator.aip.corrprocanada.com/adc/"